import {Children} from 'react';

import IntlMessageFormat from 'intl-messageformat';

export const intlFormatSingleMessage = (message: string, values?: Record<string, any> | undefined) => {
  const intlMessage = new IntlMessageFormat(message, 'en-US').format(values);
  return Array.isArray(intlMessage) ? Children.toArray(intlMessage) : intlMessage;
};
